import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';
import createNetworkingClient from 'utils/networking-client';

import ActivityDistanceNormalXsmall from '@strava/icons/ActivityDistanceNormalXsmall';
import Button from '@strava/ui/Button';
import styles from './index.scss';

function MapVisPrompt({ hideAnywhereSetting, paths }) {
  const units = I18n.measurementUnits();
  const i18nPrefix = `components.feed.map_vis_prompt.${hideAnywhereSetting}.`;

  useEffect(() => {
    createNetworkingClient().post(paths.promptImpression, {
      promo: 'map_visibility_row_reinforcement_impression'
    });
  }, []);

  const onButtonClick = () => {
    createNetworkingClient().post(paths.promptImpression, {
      promo: 'map_visibility_row_reinforcement_dismissed'
    });
    window.location.href = paths.hideAnywhere;
  };

  return (
    <div className={styles.mapVisPrompt} data-testid="map_vis_prompt_container">
      <div>
        <ActivityDistanceNormalXsmall />
      </div>
      <div
        className={styles.description}
        data-testid="map_vis_prompt_description"
      >
        {hideAnywhereSetting === 'meters_200'
          ? I18n.t(`${i18nPrefix}description_${units}`)
          : I18n.t(`${i18nPrefix}description`)}
      </div>
      <Button
        className={styles.button}
        variant="primary-outline"
        onClick={onButtonClick}
        data-testid="map_vis_prompt_button"
      >
        {I18n.t(`${i18nPrefix}button`)}
      </Button>
    </div>
  );
}

MapVisPrompt.propTypes = {
  hideAnywhereSetting: PropTypes.string.isRequired,
  paths: PropTypes.shape({
    promptImpression: PropTypes.string,
    hideAnywhere: PropTypes.string
  }).isRequired
};

export default MapVisPrompt;
